import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  KnowledgeFeature, 
  Limitations, 
  UpgradableNumber,
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import StringBox from "@components/input/strings/StringBox";
import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import LimitationsInput from "@dndComponents/limitations/LimitationsInput";

interface Props { 
  obj: KnowledgeFeature;
  disabled: boolean;
  change_time: number;
  height: number;
  attached_table?: AttachedTable;
  onChange: (changed: KnowledgeFeature) => void; 
}

export default function KnowledgeFeatureInput({
  obj,
  disabled,
  change_time,
  height,
  attached_table,
  onChange,
}: Props) {
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderLimitations = () => {
    debugger;
    if (obj.limitations.limitation_type === "None") {
      return <></>;
    } else {
      return (
        <Grid
          size={{
            xs: 12
          }}>
          <LimitationsInput
            obj={obj.limitations} 
            disabled={disabled} 
            change_time={change_time} 
            onChange={(changed: Limitations) => {
              const new_obj = obj;
              new_obj.limitations = changed.clone();
              onChange(new_obj);
            }}
          />
        </Grid>
      );
    }
  }

  return (
    <div>
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <SelectStringBox
            name="Type of Knowledge"
            options={["Adaptation","Transform","Skill", "Tool", "Language", "Eldritch Invocation", "Spell", "Creature", "CraftingRecipe"]}
            value={obj.type}
            disabled={disabled}
            onChange={(changed: string) => {
              const new_obj = obj;
              new_obj.type = changed;
              switch (new_obj.type) {
                // case "Adaptation": break;
                // case "Transform": break;
                // case "Skill": break;
                // case "Tool": break; 
                // case "Language": break; 
                // case "Eldritch Invocation": break; 
                case "Spell": new_obj.limitations.limitation_type = "Spell"; break; 
                case "Creature": new_obj.limitations.limitation_type = "Creature"; break; 
                // case "CraftingRecipe": break;
              }
              // new_obj.obj_filter = {};
              new_obj.usage_key = "";
              onChange(new_obj);
              setReloading(true);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <StringBox
            name="Usage"
            value={obj.usage_key}
            disabled={disabled}
            onBlur={(changed: string) => {
              const new_obj = obj;
              new_obj.usage_key = changed;
              onChange(new_obj);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <UpgradableNumberBox
            name="Count"
            value={obj.count}
            disabled={disabled}
            attached_table={attached_table}
            onChange={(changed: UpgradableNumber) => {
              const new_obj = obj;
              new_obj.count = changed.clone();
              onChange(new_obj);
            }}
          />
        </Grid>
        { renderLimitations() }
      </Grid>
    </div>
  ); 
}